<template>
  <div class="home">
    <div class="two_part">
      <p class="title_cn">最新文章</p>
      <div class="server">
        <div class="server_item">
          <img src="../../assets/home/u52.jpg"/>
          <p class="item_title">2019年2月份金融数据解读</p>
        </div>
        <div class="server_item">
          <img src="../../assets/home/u54.jpg"/>
          <p class="item_title">中国人民银行有关负责人就《关于加强非金融企业投资金融机构监管的指导意见》答记者问</p>
        </div>
        <div class="server_item">
          <img src="../../assets/home/u56.jpg"/>
          <p class="item_title">砥砺奋进 开拓创新 全面做好2019年金融市场和信贷政策工作</p>
        </div>
      </div>
    </div>
    <div class="two_part">
      <p class="title_cn">知识分享</p>
      <div class="server">
        <div>
          <div class="bottomBor">
            <news-list-item :data='list1'></news-list-item>
          </div>
          <div class="bottomBor">
            <news-list-item :data='list2'></news-list-item>
          </div>
          <div class="bottomBor noBottomBorder">
            <news-list-item :data='list3'></news-list-item>
          </div>
        </div>
        <div>
          <friend-link :listArr = listArr title="最新知识" type='know'></friend-link>
          <friend-link :listArr = listArr2 title="友情链接" type='link'></friend-link>
        </div>
      </div>
    </div>
    <!-- <div class="two_part">
      <p class="title_cn">保理法律法规</p>
      <div class="server">
        <div>
          <news-list-item :data='list4'></news-list-item>
          <news-list-item :data='list5'></news-list-item>
        </div>
        <div>
          <friend-link :listArr = listArr2 title="友情链接" type='link'></friend-link>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import NewsListItem from '@/components/newsComponentsItem/NewsListItem'
import FriendLink from '@/components/friendLink/FriendLink'
export default {
  name: 'home',
  components: { NewsListItem, FriendLink },
  data () {
    return {
      list1: {
        id: 333,
        imgSrc: require ('@/assets/home/u176.png'),
        date: '2018-08-06 15:47:49',
        seer: '18',
        title: '银保监会发布《关于做好2019年银行业保险业服务乡村振兴和助力脱贫攻坚工作的通知》',
        content: '根据中央经济工作会议和中央农村工作会议精神，按照党中央、国务院实施乡村振兴战略和打赢脱贫攻坚战等有关安排部署，银保监会近日发布《关于做好2019年银行业保险业服务乡村振兴和助力脱贫攻坚工作的通知》（以下简称《通知》），推动解决当前“三农”和扶贫金融服务难点。...'
      },
      list2: {
        id: 334,
        imgSrc: require ('@/assets/home/u172.png'),
        title: '强化底线思维和风险意识 坚决打好防范化解重大金融风险攻坚战',
        date: '2018-08-08 15:00:00',
        seer: '19',
        content: '2019年2月21日，人民银行2019年金融稳定工作会议在成都召开。会议以习近平新时代中国特色社会主义思想为指导，深入学习党的十九大和中央经济工作会议精神……'
      },
      list3: {
        id: 335,
        imgSrc: require ('@/assets/home/u174.png'),
        date: '2018-08-08 16:40:33',
        seer: '16',
        title: '商业保理和银行保理的区别',
        content: '银行保理侧重于融资，因此银行在办理保理业务时，不仅卖家需要有良好的财务数据和交易信息，还需要足够的抵押担保支持，以及符合银行要求的资金用途，同时还须占用企业在银行的授信额度，一般需要较长的流程和时间。所以银行保理更适用于有足够抵押和良好资质的大型企业，中小企业通常达不到银行的标准……'
      },
      list4: {
        id: 222,
        imgSrc: require ('@/assets/home/u176.png'),
        date: '2018-08-11 12:32:56',
        seer: '16',
        title: '商业保理企业管理办法',
        content: '第一章 总则第一条 立法依据为规范商业保理企业经营行为，防范行业风险，促进商 业保理行业健康发展，根据《合同法》、《公司法》、《物权法》 和有关外商投资的法律、行政法规，特制定本办法……'
      },
      list5: {
        id: 223,
        imgSrc: require ('@/assets/home/u178.png'),
        date: '2018-08-05 18:40:23',
        seer: '19',
        title: '应收账款质押登记办法',
        content: '第一章 总 则第一条 为规范应收账款质押登记，保护质押当事人和利害关系人的合法权 益，根据《中华人民共和国物权法》，制定本办法。第二条 中国人民银行征信中心(以下简称征信中心)是应收账款质押的登 记机构。'
      },
      listArr: [
        {
          imgSrc: require ('@/assets/home/u250.png'),
          title: '什么是明保理',
          time: '2018-11-09'
        },
        {
          imgSrc: require ('@/assets/home/u252.png'),
          title: '什么是暗保理',
          time: '2018-11-10'
        },
        {
          imgSrc: require ('@/assets/home/u254.png'),
          title: '什么是反向保理',
          time: '2018-11-11'
        },
      ],
      listArr2: [
        {
          imgSrc: require ('@/assets/home/u174.png'),
          title: '深圳金融办',
        },
        {
          imgSrc: require ('@/assets/home/u224.png'),
          title: '深圳保理协会',
        },
        {
          imgSrc: require ('@/assets/home/u228.png'),
          title: '百度搜索',
        }
      ]
    }
  }
}
</script>
<style lang="stylus" scoped>
.title_cn
  width 100%
  height 70px
  line-height 70px
  font-size 20px
  text-indent 30px
  font-weight bold
  padding-bottom 15px
  border-bottom 1px solid #CCCCCC
  background-color #F8F8F8
.marginLeft
  margin 0
.about_content
  line-height 25px
.two_part
  border 1px solid #CCCCCC
  width 95%
  margin 0 auto
  margin-bottom 30px
.server
  display flex
  justify-content center
  padding 20px
  .server_item
    flex 1
    padding-top 10px
    .item_title
      font-size 18px
      margin 20px 0
    img
      display block
      width 450px
      height 250px
      margin 0 auto
    p
      text-align center

.businessTitle
  font-size 18px
  margin-top 20px

.bottomBor
  border-bottom 1px solid #cccccc
  margin-bottom 20px
</style>
